import { type MonthAbbr } from '../types';

// Map of month abbreviations to Thai month names
export const THAI_MONTH_NAMES: Record<MonthAbbr, string> = {
  JAN: 'มกราคม',
  FEB: 'กุมภาพันธ์',
  MAR: 'มีนาคม',
  APR: 'เมษายน',
  MAY: 'พฤษภาคม',
  JUN: 'มิถุนายน',
  JUL: 'กรกฎาคม',
  AUG: 'สิงหาคม',
  SEP: 'กันยายน',
  OCT: 'ตุลาคม',
  NOV: 'พฤศจิกายน',
  DEC: 'ธันวาคม',
};

export const MONTH_ORDER: MonthAbbr[] = [
  'JAN',
  'FEB',
  'MAR',
  'APR',
  'MAY',
  'JUN',
  'JUL',
  'AUG',
  'SEP',
  'OCT',
  'NOV',
  'DEC',
];
